import React, { useCallback, useEffect, useState } from "react";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import { routeName } from "../../../routes/routeName";
import { MenuItem, Typography } from "@mui/material";
import {
  ButtonOutlined,
  ButtonPrimary,
} from "../../../components/button/ButtonCustoms";
import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import { NavigateFunction, useNavigate } from "react-router-dom";
import FilterSelect from "../../../components/select/filterSelect";
import CardChat from "../../../components/card/CardChat";
import CustomStatus from "../../../components/chip/CustomStatus";
import { FiberManualRecord } from "@mui/icons-material";
import InputTextField from "../../../components/input/inputTextField";
import { dataEvaluation } from "../../../utils/usage_form_evluation";
import { advisorTypeApi } from "../../../api/advisor-type/advisor-type.api";
import { EmployeeApi } from "../../../api/employee/employee.api";
import AutocompleteSelect from "../../../components/select/autoCompleteSelect";
import { useDispatch, useSelector } from "react-redux";
import { advisorStudentApi } from "../../../api/advisor-student/advisor-student.api";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { alertError, alertSuccess } from "../../../components/alert/swal";
import { advisorApi } from "../../../api/advisor/advisor.api";
import { facultyApi } from "../../../api/factulty/factulty.api";
import { advisorRequestApi } from "../../../api/advisor-request/advisor-request.api";
import ImageTracking from "../../../components/upload/MultiUploadFile";
import { colors } from "../../../constants/colors";
import { advisorEstimateApi } from "../../../api/advisor-estimate/advisor-estimate.api";
import { classRoomStudentApi } from "../../../api/class-room-student/class-room-student.api";
import { CourseOfStudyApi } from "../../../api/course-of-study/course-of-study.api";
import { CourseApi } from "../../../api/course/course.api";
import { CourseAnnualApi } from "../../../api/course-annual/course-annual.api";

const CreateConsultation = () => {
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();
  const { profile } = useSelector((state: any) => state.profile);
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const [inputValue, setInputValue] = useState({
    selected_usage_type: "",
    selected_advisor_type: 0,
    selected_advisor_type_name: "",
    selected_advisor_id: 0,
    selected_employee_id: 0,
    selected_faculty_id: 0,
    detail: "",
  });

  const [errorMessage, setErrorMessage] = useState<any[]>([]);

  const [dataAdvisorType, setDataAdvisorType] = useState<any[]>([]);
  const [dataAdvisor, setDataAdvisor] = useState<any[]>([]);
  const [dataEmployee, setDataEmployee] = useState<any[]>([]);
  const [faculty, setFaculty] = useState<any[]>([]);
  const [dataRequest, setDataRequest] = useState<any>({});
  const [imageConsult, setImageConsult] = useState<any[]>([]);


  const [class_advisor_data, set_class_advisor_data] = useState<any[]>([]);
  const [subject_advisor_data, set_subject_advisor_data] = useState<any[]>([]);
  const [course_data, set_course_data] = useState<any[]>([]);



  const handleChangeImageConsult = (newFile: any) => {
    const newArray = Array.isArray(newFile) ? newFile : [newFile];
    if (newFile?.length > 0) {
      setImageConsult([...imageConsult, ...newArray]);
    } else {
      setImageConsult([...imageConsult, newFile]);
    }
  };
  const handleDeleteImageConsult = (index_file: number) => {
    setImageConsult((prev) => prev.filter((_, i: number) => i !== index_file));
  };

  const handleChangeValue = (name: string, value: any) => {
    setInputValue((prev: any) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const getAdvisorType = async () => {
    const res = await advisorTypeApi.getAllAdvisorType();
    const data = res.data;
    if (data.status < 300) {
      setDataAdvisorType(data.data.items);
    } else {
      setDataAdvisorType([]);
    }
  };

  const getFaculty = async () => {
    await facultyApi.listFaculty().then((res) => {
      if (res.status < 300) {
        const data = res.data;
        setFaculty(data.data);
      } else {
        setFaculty([]);
      }
    }).catch((err) => {
      console.log(err)
    })
  };





  // อาจารย์ประจำชั้น
  const getClassAdvisor = async () => {
    const res = await classRoomStudentApi.getClassRoomStudent();
    const data = res.data;
    if (data.status < 300) {
      set_class_advisor_data(data.data || []);
    } else {
      set_class_advisor_data([]);
    }
  };
  // อาจารย์ประจำรายวิชา
  const getSubjectAdvisor = useCallback(async (id_courses: number) => {
    await CourseAnnualApi.listDropdownByCourse(id_courses).then((res) => {
      if (res.status < 300) {
        const response = res.data?.data;
        set_subject_advisor_data(response || []);
      }
    }).catch((err) => {
      console.log(err)
    })
  }, [inputValue.selected_faculty_id])


  const handleGetCourse = async () => {
    await CourseApi.listDropdown().then((res) => {
      if (res.status < 300) {
        const response = res.data.data || [];
        set_course_data(response)
      }
    }).catch((err) => {
      console.log(err)
    })
  }


  const getDataEmployee = async () => {
    let query: any = {
      page: 1,
      limit: 1000000,
    };

    const res = await EmployeeApi.list(query);
    const data = res.data;
    if (data.status < 300) {
      setDataEmployee(data.data.items);
    } else {
      setDataEmployee([]);
    }
  };

  const getSingleRequest = async () => {
    const res = await advisorRequestApi.getAdvisorRequestByUserLogin();
    const data = res.data;
    if (data.status < 300) {
      setDataRequest(data.data);
    }
  };

  useEffect(() => {
    if (inputValue.selected_faculty_id) {
      getSubjectAdvisor(inputValue.selected_faculty_id);
    }
  }, [getSubjectAdvisor])

  useEffect(() => {
    getAdvisorType();
    getClassAdvisor();
    getDataEmployee();
    getFaculty();
    handleGetCourse();
    getSingleRequest();
  }, []);

  const handleUploadFile = async (consult_id?: number, newFile?: any) => {
    if (newFile && newFile.length > 0 && consult_id) {
      let formData = new FormData();

      for (let i = 0; i < newFile.length; i++) {
        formData.append("files", newFile[i].file); // "files" should match your backend field name
      }

      try {
        const response = await advisorStudentApi.updloadConsultFile(
          consult_id,
          formData
        );
        if (response.status < 300) {
          dispatch(unsetLoading());
          alertSuccess(
            "ส่งเรื่องขอคำปรึกษา",
            "ส่งเรื่องขอคำปรึกษา เรียบร้อยแล้ว",
            undefined,
            () => {
              navigate(
                routeName.student.studentConsultation + `/${consult_id}/update`
              );
            }
          );
        }
      } catch (error) {
        alertError("บันทึกเอกสาร ไม่สำเร็จ");
        dispatch(unsetLoading());
      } finally {
        dispatch(unsetLoading());
      }
    } else {
      dispatch(unsetLoading());
    }
  };

  const validateForm = (type: string) => {
    console.log("type", type);
    if (
      type === "อาจารย์ที่ปรึกษาประจำชั้น" &&
      inputValue.selected_usage_type
    ) {
      const errors: string[] = [];

      // Check if required fields are empty
      if (!inputValue.selected_usage_type) {
        errors.push("selected_usage_type");
      }

      // Check if required fields are empty
      if (!inputValue.selected_advisor_type) {
        errors.push("selected_advisor_type");
      }

      // Check if required fields are empty
      if (!inputValue.selected_employee_id) {
        errors.push("selected_employee_id");
      }

      // Check if required fields are empty
      if (!inputValue.detail) {
        errors.push("detail");
      }

      setErrorMessage(errors);

      // If there are no errors, return true
      return errors.length === 0;
    } else if (
      type === "อาจารย์ที่ปรึกษาประจำรายวิชา" &&
      inputValue.selected_usage_type
    ) {
      const errors: string[] = [];

      // Check if required fields are empty
      if (!inputValue.selected_usage_type) {
        errors.push("selected_usage_type");
      }

      // Check if required fields are empty
      if (!inputValue.selected_faculty_id) {
        errors.push("selected_faculty_id");
      }

      // Check if required fields are empty
      // if (!inputValue.selected_advisor_id) {
      //   errors.push("selected_advisor_id");
      // }

      // Check if required fields are empty
      if (!inputValue.detail) {
        errors.push("detail");
      }

      setErrorMessage(errors);

      // If there are no errors, return true
      return errors.length === 0;
    } else if (
      type === "อาจารย์ที่ปรึกษาวิทยานิพนธ์" &&
      inputValue.selected_usage_type
    ) {
      const errors: string[] = [];

      // Check if required fields are empty
      if (!inputValue.detail) {
        errors.push("detail");
      }

      setErrorMessage(errors);

      // If there are no errors, return true
      return errors.length === 0;
    } else {
      const errors: string[] = [];

      // Check if required fields are empty
      if (!inputValue.selected_usage_type) {
        errors.push("selected_usage_type");
      }

      setErrorMessage(errors);

      // If there are no errors, return true
      return errors.length === 0;
    }
  };

  console.log(errorMessage, 'errors')
  const handleSave = async (body: any, imageConsult?: any) => {
    if (validateForm(body.selected_usage_type)) {
      try {
        dispatch(setLoading());

        const bodyJson = {
          advisor_group: body.selected_usage_type,
          advisor_type: body.selected_advisor_type,
          advisor_type_name: body.selected_advisor_type_name,
          faculty_id: body.selected_faculty_id,
          detail: body.detail,
          status: "pending",
          last_updated_by: "student",
          // profile && profile.user_type === "student" ? "student" : "advisor",
          chat: [
            {
              chat_id: new Date().getTime(),
              chat_type: "student",
              // profile && profile.user_type === "student"
              //   ? "นักศึกษา"
              //   : "อาจารย์ที่ปรึกษา",
              message: body.detail,
              send_date: new Date(),
              send_by: (profile && profile.id_user) ?? 0,
              send_to:
                profile && profile.user_type === "student"
                  ? body.selected_employee_id
                  : 0,
            },
          ],
        };

        let check_id_advisor: string | null = null;
        let check_id_employee: string | null = null;


        let id_advisor: number | null = null; // อาจารย์ที่ปรึกษาวิทยานิพนธ์
        let id_employee: number | null = null; // อาจารย์ที่ปรึกษาประจำรายวิชา
        let id_class_room_employee: number | null = null; // อาจารย์ที่ปรึกษาประจำชั้น


        if (body.selected_usage_type === "อาจารย์ที่ปรึกษาวิทยานิพนธ์") {
          id_advisor = dataRequest?.id_advisor ?? null;
          // check_id_advisor = dataRequest?.id_advisor ?? null;
          // check_id_employee = dataRequest?.id_employee ?? null;
        } else if (body.selected_usage_type == "อาจารย์ที่ปรึกษาประจำรายวิชา") {
          id_employee = body?.selected_employee_id ?? null;
        } else {
          id_class_room_employee = body.selected_employee_id
          // check_id_advisor = body.selected_advisor_id ?? null;
          // check_id_employee = body.selected_employee_id ?? null;
        }

        const newBody = {
          advisor_group: body.selected_usage_type,
          id_advisor: id_advisor,
          id_employee: id_employee,
          id_class_room_employee: id_class_room_employee,
          id_student: profile.id_student ?? null,
          advisor_student_detaill: JSON.stringify(bodyJson),
        };

        const response = await advisorStudentApi.createAdvisorStudent(newBody);

        if (response.status < 300 && response?.data?.data?.id_advisor_student) {
          const resAdvisorEstimate = await advisorEstimateApi.getEstimateById(
            response?.data?.data?.id_advisor_student
          );
          if (resAdvisorEstimate.data.status === 200) {
            if (
              response?.data?.data?.id_advisor_student &&
              imageConsult.length > 0
            ) {
              handleUploadFile(
                response?.data?.data?.id_advisor_student,
                imageConsult
              );
            } else {
              dispatch(unsetLoading());
              alertSuccess(
                "ส่งเรื่องขอคำปรึกษา",
                "ส่งเรื่องขอคำปรึกษา เรียบร้อยแล้ว",
                undefined,
                () => {
                  navigate(
                    routeName.student.studentConsultation +
                    `/${response.data?.data?.id_advisor_student}/update`
                  );
                }
              );
            }
          }
        }
      } catch (error) {
        alertError("ส่งเรื่องขอคำปรึกษา ไม่สำเร็จ");
        dispatch(unsetLoading());
      } finally {
        dispatch(unsetLoading());
      }
    }
  };

  return (
    <div className="h-auto">
      {/* breadcrumbs */}
      <NavigateListCustom
        navigateData={[
          {
            name: "อาจารย์ที่ปรึกษา",
            key: "1",
            pathName: routeName.student.chooseAdvisor,
          },
          {
            name: "ส่งเรื่องขอคำปรึกษา",
            key: "2",
            pathName: location.pathname,
          },
        ]}
      />

      {/* header */}
      <section className="my-4">
        <Typography variant="h3">ส่งเรื่องขอคำปรึกษา </Typography>
      </section>

      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 lg:col-span-6 md:col-span-6 sm:col-span-12">
          <FilterSelect
            heading={"เลือกประเภท"}
            helperText={
              errorMessage.includes("selected_usage_type")
                ? "ประเภทคำปรึกษา"
                : ""
            }
            value={inputValue.selected_usage_type ?? ""}
            labelId="type-id"
            selectId="type-select-id"
            placeholder="เลือกรูปแบบคำปรึกษา"
            required
            options={[
              // {
              //   id_type: "0",
              //   type_name: "เลือกประเภท",
              // },
              ...dataEvaluation.map((list) => ({
                id_type: list.id,
                type_name: list.name,
              })),
            ].map((list, index) => (
              <MenuItem value={list.id_type} key={index + 1}>
                {list.type_name}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setInputValue({
                ...inputValue,
                selected_usage_type: e.target.value,
                selected_advisor_type: 0,
                selected_advisor_type_name: "",
                selected_advisor_id: 0,
                selected_employee_id: 0,
                selected_faculty_id: 0,
                detail: "",
              });
              setErrorMessage([]);
            }}
          />
        </article>

        <article className="w-full col-span-12 lg:col-span-6 md:col-span-6 sm:col-span-12">
          <FilterSelect
            heading={"ประเภทคำปรึกษา"}
            placeholder="เลือกประเภทคำปรึกษา"
            helperText={
              errorMessage.includes("selected_advisor_type")
                ? "ระบุประเภทคำปรึกษา"
                : ""
            }
            value={inputValue.selected_advisor_type ?? ""}
            labelId="type-id"
            selectId="type-select-id"
            required
            options={[
              ...dataAdvisorType.map((list) => ({
                id_type: list.id_advisor_type,
                type_name: list.advisor_type_name,
              })),
            ].map((list, index) => (
              <MenuItem value={list.id_type} key={index + 1}>
                {list.type_name}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              // console.log("selected_advisor_type_name", e.target.value);
              // setInputValue({
              //   ...inputValue,
              // });
              setInputValue({
                ...inputValue,
                selected_advisor_type: +e.target.value,
                selected_advisor_type_name:
                  dataAdvisorType.find(
                    (list) => list.id_advisor_type === e.target.value
                  ).advisor_type_name || "",
              });
            }}
          />
        </article>

        {inputValue &&
          inputValue.selected_usage_type === "อาจารย์ที่ปรึกษาประจำชั้น" && (
            <>
              <article className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12">
                <AutocompleteSelect
                  heading={"อาจารย์ที่ต้องการปรึกษา"}
                  helperText={
                    errorMessage.includes("selected_employee_id")
                      ? "ระบุอาจารย์ที่ต้องการปรึกษา"
                      : ""
                  }
                  freeSolo
                  labelId={"-"}
                  options={class_advisor_data ?? []}
                  getOptionLabel={(option: any) =>
                    `${option?.first_name} ${option?.last_name || "-"}` || ""
                  }
                  value={class_advisor_data?.find((x) => x?.id_class_room_employee == inputValue.selected_employee_id) || null}
                  required
                  onChange={(_, value: any) => {
                    if (value) {
                      handleChangeValue(
                        "selected_employee_id",
                        value.id_class_room_employee
                      );
                    }
                  }}
                />
              </article>

              {/* <article className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12">
          <AutocompleteSelect
            heading={"ค้นหาอาจารย์ที่ปรึกษา"}
            freeSolo
            labelId={"-"}
            options={dataEmployee ?? []}
            getOptionLabel={(option: any) => `${option?.fullname}` || ""}
            renderOption={(props, option) => (
              <li {...props}>{`${option?.fullname}`}</li>
            )}
            onChange={(_, value: any) => {
              console.log("value", value);
              if (value) {
                handleChangeValue("selected_employee_id", value.id_employee);
              }
            }}
          />
        </article> */}
              <article className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12">
                <InputTextField
                  heading={"รายละเอียด"}
                  placeholder={"ระบุรายละเอียด"}
                  helperText={
                    errorMessage.includes("detail")
                      ? "รายละเอียด is required."
                      : ""
                  }
                  value={inputValue.detail}
                  onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleChangeValue("detail", e.target.value)
                  }
                  row={3}
                  maxRows={5}
                  disablePaddingMultiline
                  multiline
                  required
                  inputHeight={"auto"}
                />
              </article>
            </>
          )}

        {inputValue &&
          inputValue.selected_usage_type === "อาจารย์ที่ปรึกษาประจำรายวิชา" && (
            <>
              <article className="w-full col-span-12 lg:col-span-6 md:col-span-6 sm:col-span-12">
                <AutocompleteSelect
                  heading={"รายวิชา"}
                  helperText={
                    errorMessage.includes("selected_faculty_id")
                      ? "ระบุรายวิชา"
                      : ""
                  }
                  freeSolo
                  labelId={"-"}
                  placeholder="เลือกรายวิชา"
                  options={course_data ?? []}
                  getOptionLabel={(option: any) =>
                    `${option?.courses_no || ""} / ${option?.courses_name}` || ""
                  }
                  required
                  renderOption={(props, option) => (
                    <li {...props}>{`${option?.courses_no || ""} / ${option?.courses_name || ""}`}</li>
                  )}
                  value={course_data?.find((x) => x?.id_courses == inputValue.selected_faculty_id) || null}
                  onChange={(_, value: any) => {
                    handleChangeValue(
                      "selected_faculty_id",
                      value?.id_courses || ""
                    );
                    // handleChangeValue(
                    //   "selected_employee_id",
                    //   value.id_employee
                    // );
                  }}
                />
              </article>

              <article className="w-full col-span-12 lg:col-span-6 md:col-span-6 sm:col-span-12">
                <AutocompleteSelect
                  heading={"อาจารย์ที่ต้องการปรึกษา"}
                  helperText={
                    errorMessage.includes("selected_employee_id")
                      ? "ระบุอาจารย์ที่ต้องการปรึกษา"
                      : ""
                  }
                  placeholder="เลือกอาจารย์ที่ต้องการปรึกษา"
                  // freeSolo
                  labelId={"DDD_d"}
                  options={subject_advisor_data || []}
                  getOptionLabel={(option: any) => option?.full_name || ""}
                  value={subject_advisor_data?.find((x) => x?.id_employee == inputValue.selected_employee_id) || null}
                  required
                  disabled={!inputValue.selected_faculty_id}
                  onChange={(_, value: any) => {
                    handleChangeValue(
                      "selected_employee_id",
                      value?.id_employee || ""
                    );
                  }}
                />
                {/* <AutocompleteSelect
                  heading={"อาจารย์ที่ต้องการปรึกษา"}
                  helperText={
                    errorMessage.includes("selected_advisor_id")
                      ? "ระบุอาจารย์ที่ต้องการปรึกษา"
                      : ""
                  }
                  freeSolo
                  labelId={"-"}
                  options={dataAdvisor ?? []}
                  getOptionLabel={(option: any) =>
                    `${option?.first_name} ${option?.last_name || "-"}` || ""
                  }
                  required
                  renderOption={(props, option) => (
                    <li
                      {...props}
                    >{`${option?.first_name} ${option?.last_name}`}</li>
                  )}
                  // value={inputValue.adv_employee_id ?? null}
                  onChange={(_, value: any) => {
                    if (value) {
                      handleChangeValue(
                        "selected_advisor_id",
                        value.id_advisor
                      );
                      handleChangeValue(
                        "selected_employee_id",
                        value.id_employee
                      );
                    }
                  }}
                /> */}
              </article>

              <article className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12">
                <InputTextField
                  heading={"รายละเอียด"}
                  placeholder={"ระบุรายละเอียด"}
                  helperText={
                    errorMessage.includes("detail")
                      ? "ระบุรายละเอียด"
                      : ""
                  }
                  value={inputValue.detail}
                  onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleChangeValue("detail", e.target.value)
                  }
                  row={3}
                  maxRows={5}
                  disablePaddingMultiline
                  multiline
                  required
                  inputHeight={"auto"}
                />
              </article>
            </>
          )}

        {inputValue &&
          inputValue.selected_usage_type === "อาจารย์ที่ปรึกษาวิทยานิพนธ์" && (
            <>
              <article className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12">
                <InputTextField
                  heading={"รายละเอียด"}
                  helperText={
                    errorMessage.includes("detail")
                      ? "รายละเอียด is required."
                      : ""
                  }
                  placeholder={"ระบุรายละเอียด"}
                  value={inputValue.detail}
                  onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleChangeValue("detail", e.target.value)
                  }
                  required
                  row={3}
                  maxRows={5}
                  disablePaddingMultiline
                  multiline
                  inputHeight={"auto"}
                />
              </article>
            </>
          )}
      </div>

      <ImageTracking
        headingVariant="h6"
        sxHeading={{ color: colors.themeMainColor }}
        heading="แนบรูปภาพ"
        handleDeleteImageApi={() => { }}
        handleDeleteImageSelect={(_, index: number) =>
          handleDeleteImageConsult(index)
        }
        onUploadMedia={() => { }}
        onChange={handleChangeImageConsult}
        tabIndex={1}
        valueAddFile={imageConsult}
        valueImage={[]}
      />

      <section
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "24px",
        }}
      >
        <ButtonOutlined
          onClick={() => {
            if (window.history.length > 0) {
              navigate(-1)
            } else {
              navigate({ pathname: routeName.student.chooseAdvisor, search: `?${searchParams.toString()}` });
            }
          }}
          mode="del"
          buttonName="ยกเลิก"
          btnProps={{
            width: "125px",
            margin: "12px",
          }}
        />

        <ButtonPrimary
          onClick={() => {
            handleSave(inputValue, imageConsult ? imageConsult : undefined);
          }}
          mode="success"
          buttonName="ยืนยัน"
          btnProps={{
            width: "125px",
            margin: "12px",
          }}
        />
      </section>
    </div>
  );
};

export default CreateConsultation;
